import { Progress, Tooltip } from "antd";
import moment from "moment";
import useRefreshTimer from "../../../hooks/api/useRefreshTimer";
import { PiClockCountdown } from "react-icons/pi";

function RefreshTimerBar({ intervalMinutes = 5 }) {
  const { timeLeft, percentage } = useRefreshTimer(intervalMinutes);
  const duration = moment.duration(timeLeft);

  const formattedTime = `${duration.minutes()}m ${duration.seconds()}s`;

  const text = `Next signal in ${formattedTime}`;

  return (
    <Tooltip title={`Next refresh in ${formattedTime}`} placement="bottom">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          width: "100%",
          marginBottom: "1rem",
          flexWrap: "wrap",
          color: "#6D6D6D",
        }}
      >
        {/*<FaRegClock style={{ color: "#0c4cfc" }} />*/}
        <PiClockCountdown />
        <span style={{ fontSize: "11px" }}>{text}</span>
        <Progress
          percent={percentage}
          percentPosition={{ align: "end", type: "inner" }}
          strokeColor="#0c4cfc"
          trailColor="#d6d6d6"
          showInfo={false}
          size="small"
          // size={["100%", 15]}
          // style={{ width: 120 }}
        />
      </div>
    </Tooltip>
  );
}

export default RefreshTimerBar;
